"use strict";

var _toConsumableArray = require("/shared/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/shared/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorldMap = void 0;

var tslib_1 = require("tslib");

var React = require("react");

var d3_geo_1 = require("d3-geo");

var countries_geo_1 = require("./countries.geo");

var constants_1 = require("./constants");

var utils_1 = require("./utils");

var draw_1 = require("./draw");

var Frame_1 = require("./components/Frame");

var Region_1 = require("./components/Region");

var TextLabel_1 = require("./components/TextLabel");

(0, tslib_1.__exportStar)(require("./types"), exports);

function WorldMap(props) {
  var data = props.data,
      title = props.title,
      _props$valuePrefix = props.valuePrefix,
      valuePrefix = _props$valuePrefix === void 0 ? '' : _props$valuePrefix,
      _props$valueSuffix = props.valueSuffix,
      valueSuffix = _props$valueSuffix === void 0 ? '' : _props$valueSuffix,
      _props$color = props.color,
      color = _props$color === void 0 ? constants_1.defaultColor : _props$color,
      _props$strokeOpacity = props.strokeOpacity,
      strokeOpacity = _props$strokeOpacity === void 0 ? 0.2 : _props$strokeOpacity,
      _props$backgroundColo = props.backgroundColor,
      backgroundColor = _props$backgroundColo === void 0 ? 'white' : _props$backgroundColo,
      _props$tooltipBgColor = props.tooltipBgColor,
      tooltipBgColor = _props$tooltipBgColor === void 0 ? 'black' : _props$tooltipBgColor,
      _props$tooltipTextCol = props.tooltipTextColor,
      tooltipTextColor = _props$tooltipTextCol === void 0 ? 'white' : _props$tooltipTextCol,
      _props$size = props.size,
      size = _props$size === void 0 ? constants_1.defaultSize : _props$size,
      _props$frame = props.frame,
      frame = _props$frame === void 0 ? false : _props$frame,
      _props$frameColor = props.frameColor,
      frameColor = _props$frameColor === void 0 ? 'black' : _props$frameColor,
      _props$borderColor = props.borderColor,
      borderColor = _props$borderColor === void 0 ? 'black' : _props$borderColor,
      _props$richInteractio = props.richInteraction,
      richInteraction = _props$richInteractio === void 0 ? false : _props$richInteractio,
      _props$styleFunction = props.styleFunction,
      styleFunction = _props$styleFunction === void 0 ? (0, constants_1.defaultCountryStyle)(borderColor, strokeOpacity) : _props$styleFunction,
      _props$tooltipTextFun = props.tooltipTextFunction,
      tooltipTextFunction = _props$tooltipTextFun === void 0 ? constants_1.defaultTooltip : _props$tooltipTextFun,
      onClickFunction = props.onClickFunction,
      hrefFunction = props.hrefFunction,
      _props$textLabelFunct = props.textLabelFunction,
      textLabelFunction = _props$textLabelFunct === void 0 ? function () {
    return [];
  } : _props$textLabelFunct;
  var windowWidth = (0, utils_1.useWindowWidth)();
  var width = typeof size === 'number' ? size : (0, utils_1.responsify)(size, windowWidth);
  var height = width * constants_1.heightRatio;

  var _React$useState = React.useState(1),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      scale = _React$useState2[0],
      setScale = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      translateX = _React$useState4[0],
      setTranslateX = _React$useState4[1];

  var _React$useState5 = React.useState(0),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      translateY = _React$useState6[0],
      setTranslateY = _React$useState6[1];

  var containerRef = React.createRef();
  var countryValueMap = Object.fromEntries(data.map(function (_ref) {
    var country = _ref.country,
        value = _ref.value;
    return [country.toUpperCase(), value];
  }));
  var minValue = Math.min.apply(Math, _toConsumableArray(data.map(function (_ref2) {
    var value = _ref2.value;
    return value;
  })));
  var maxValue = Math.max.apply(Math, _toConsumableArray(data.map(function (_ref3) {
    var value = _ref3.value;
    return value;
  })));
  var projection = (0, d3_geo_1.geoMercator)();
  var pathGenerator = (0, d3_geo_1.geoPath)().projection(projection);
  var regions = countries_geo_1.default.features.map(function (feature, idx) {
    var triggerRef = React.createRef();
    var isoCode = feature.I,
        countryName = feature.N,
        coordinates = feature.C;
    var geoFeature = {
      type: 'Feature',
      properties: {
        NAME: countryName,
        ISO_A2: isoCode
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: coordinates
      }
    };
    var context = {
      countryCode: isoCode,
      countryValue: countryValueMap[isoCode],
      countryName: countryName,
      color: color,
      minValue: minValue,
      maxValue: maxValue,
      prefix: valuePrefix,
      suffix: valueSuffix
    };
    var path = React.createElement(Region_1.default, {
      ref: triggerRef,
      d: pathGenerator(geoFeature),
      style: styleFunction(context),
      onClick: function onClick(event) {
        return onClickFunction === null || onClickFunction === void 0 ? void 0 : onClickFunction(Object.assign(Object.assign({}, context), {
          event: event
        }));
      },
      strokeOpacity: strokeOpacity,
      href: hrefFunction === null || hrefFunction === void 0 ? void 0 : hrefFunction(context),
      key: "path".concat(idx)
    });
    var tooltip = (0, draw_1.drawTooltip)(typeof context.countryValue === 'undefined' ? undefined : tooltipTextFunction(context), tooltipBgColor, tooltipTextColor, idx, triggerRef, containerRef);
    return {
      path: path,
      highlightedTooltip: tooltip
    };
  });
  var regionPaths = regions.map(function (entry) {
    return entry.path;
  });
  var regionTooltips = regions.map(function (entry) {
    return entry.highlightedTooltip;
  });
  var eventHandlers = {
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onDoubleClick: function onDoubleClick(e) {
      var rect = e.currentTarget.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;

      if (scale === 4) {
        setTranslateX(0);
        setTranslateY(0);
        setScale(1);
      } else {
        setTranslateX(2 * translateX - x);
        setTranslateY(2 * translateY - y);
        setScale(scale * 2);
      }
    }
  };
  return React.createElement("figure", {
    className: "worldmap__figure-container",
    style: {
      backgroundColor: backgroundColor
    }
  }, title && React.createElement("figcaption", {
    className: "worldmap__figure-caption"
  }, title), React.createElement("svg", Object.assign({
    ref: containerRef,
    height: "".concat(height, "px"),
    width: "".concat(width, "px")
  }, richInteraction ? eventHandlers : undefined), frame && React.createElement(Frame_1.default, {
    color: frameColor
  }), React.createElement("g", {
    transform: "translate(".concat(translateX, ", ").concat(translateY, ") scale(").concat(width / 960 * scale, ") translate(0, 240)"),
    style: {
      transition: 'all 0.2s'
    }
  }, regionPaths), React.createElement("g", null, textLabelFunction(width).map(function (props, idx) {
    return React.createElement(TextLabel_1.default, Object.assign({}, props, {
      key: "text_".concat(idx)
    }));
  })), regionTooltips));
}

exports.default = WorldMap;
exports.WorldMap = WorldMap;